import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../..";
import putNotaFiscal from "../queries/putNotaFiscal";
import { NotaFiscalProps } from "../types";

export default function usePutNotaFiscal(onSuccessEditNotaFiscal: () => void) {
  return useMutation(
    ({
      notaFiscalAtual,
      id,
      data,
    }: {
      notaFiscalAtual: NotaFiscalProps;
      id: number;
      data: NotaFiscalProps;
    }) => {
      //@ts-ignore
      Object.keys(data as any).forEach((key: string) => data[key] === undefined && delete data[key]);

      Object.assign(notaFiscalAtual, data);

      return putNotaFiscal(id, notaFiscalAtual, () => onSuccessEditNotaFiscal());
    },
    {
      onSuccess(_, { id }) {
        queryClient.invalidateQueries();
      },
    }
  );
}
